import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'
import service from '@/utils/request.js'
import '@/icons' // icon
import '@/permission' // permission control
import VueClipboard from 'vue-clipboard2'

// 引入echarts
import echarts from 'echarts'

Vue.prototype.$echarts = echarts
/* 引入echarts工具 */
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'

require('echarts/extension/bmap/bmap');
import "echarts/map/js/china"; // 引入中国地图数据

// 引入事件通信插件
import mitt from 'mitt';

Vue.use(ElementUI, { locale })
Vue.use(VCharts)
Vue.use(VueClipboard)

Vue.prototype.$http = {}
Vue.prototype.$http = service;
Vue.config.productionTip = false

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

//引入mock
// import '@/mock' 

/**
 * CKEditor4
 */
import CKEditor from 'ckeditor4-vue';
Vue.use(CKEditor);
// https://github.com/developit/mitt
Vue.prototype.$bus = mitt();

// 注册全局自定义指令
import dateRangeInstant from '@/components/dateRangeInstant'
Vue.directive('date-range-instant', dateRangeInstant)

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js